module.exports = __webpack_public_path__ + "static/media/d-app1.a93d52d3.svg";